<template>
  <vs-row style="height: 100%; position:relative;">
    <vs-col vs-w="12">
      <div class="vx-card form-card" ref="card">
        <div class="vx-card__header">
          <vs-col vs-type="flex" vs-justify="space-between" vs-align="center" vs-w="12" vs-lg="12" vs-sm="12" vs-xs="12">
            <h3>{{ [this.id ? 'MODIFICA' : 'NUOVO','RIMBORSO'].join(' ')}}</h3>
            <feather-icon icon="XIcon" @click="closeSidebar" class="cursor-pointer"></feather-icon>
          </vs-col>
        </div>
        <vs-divider />
        <form-wizard ref="wiz" autofocus v-on:submit.prevent="stop" color="rgba(var(--vs-primary), 1)" errorColor="rgba(var(--vs-danger), 1)" :title="null" :subtitle="null" nextButtonText="Avanti" backButtonText="Indietro" finishButtonText="Salva" @on-complete="onSalva">
          <!-- tab 1 content -->
          <tab-content title="Rimborso" class="mb-5" icon="feather icon-pocket" :before-change="validateStep1">
            <form data-vv-scope="step-1">
              <vs-row justify="center">
                <vs-col class="md:w-6/12 w-full" w="2">
                  <vs-col v-if="!checkDisabled" vs-type="flex" vs-justify="flex-start" class="mt-4">
                    <label class="text-sm mr-6">Scegli il tipo:</label>
                    <vs-radio v-model="radio_ca" vs-value="azienda" class=" mr-4">Azienda</vs-radio>
                    <vs-radio v-model="radio_ca" vs-value="contatto" >Contatto</vs-radio>
                  </vs-col>
                  <vs-col class="mt-4" v-if="radio_ca == 'azienda'" :key="selectorKey">
                    <label class="text-sm">Azienda</label>
                    <v-select :disabled="checkDisabled" name="azienda" placeholder="Scrivi l'azienda da selezionare.." :options="aziende" @search="fetchAziende" v-model="azienda" v-validate="radio_ca == 'azienda' ? 'required' : ''" :filterable="false"><span slot="no-options">Nessun risultato</span></v-select>
                    <span class="text-danger text-sm" v-show="errors.has('step-1.azienda')">{{ errors.first('step-1.azienda') }}</span>
                  </vs-col>
                  <vs-col class="mt-4" v-if="azienda && azienda.contatti && azienda.contatti.find( c => c.id_ruolo == 1 || c.id_ruolo == 93)">
                    <label class="text-sm">Titolare/Legale Rappresentante</label>
                    <p>
                      {{[azienda.contatti.find( c => c.id_ruolo == 1 || c.id_ruolo == 93).contatto.cognome,azienda.contatti.find( c => c.id_ruolo == 1 || c.id_ruolo == 93).contatto.nome].join(" ")}}
                    </p>
                  </vs-col>
                  <vs-col class="mt-4" v-if="radio_ca == 'contatto'" :key="selectorKey">
                    <label class="text-sm">Contatto</label>
                    <v-select :disabled="checkDisabled" name="contatto" placeholder="Scrivi il contatto da selezionare.." :options="contatti" @search="fetchContatti" v-model="contatto" v-validate="radio_ca == 'contatto' ? 'required' : ''" :filterable="false"><span slot="no-options">Nessun risultato</span></v-select>
                    <span class="text-danger text-sm" v-show="errors.has('step-1.contatto')">{{ errors.first('step-1.contatto') }}</span>
                  </vs-col>
                  <vs-col class="mt-2">
                    <label class="vs-input--label">Codice Ufficio</label>
                    <v-select :disabled="checkDisabled" placeholder="Ufficio" :options="codici_ufficio.length ? codici_ufficio : []" class="w-full" v-model="codice_ufficio" name="codice_ufficio" v-validate="'required'" :filterable="false"><span slot="no-options">Nessun risultato</span></v-select>
                    <span class="text-danger text-sm" v-show="errors.has('step-1.servizio')">{{ errors.first('step-1.codice_ufficio') }}</span>
                  </vs-col>
                  <!-- <vs-col class="mt-2">
                    <label class="vs-input--label">Codice Ufficio</label>
                    <v-select placeholder="Scegli ufficio.." :options="uffici" v-model="ufficio" name="ufficio" v-validate="'required'" :filterable="false"><span slot="no-options">Nessun risultato</span></v-select>
                    <span class="text-danger text-sm" v-show="errors.has('step-1.ufficio')">{{ errors.first('step-1.ufficio') }}</span>
                  </vs-col> -->
                  <vs-col class="mt-2">
                    <label class="vs-input--label">Servizio</label>
                    <v-select :disabled="checkDisabled" placeholder="Scegli il servizio..." :options="servizi" v-model="servizio" name="servizio" v-validate="'required'" :filterable="false"><span slot="no-options">Nessun risultato</span></v-select>
                    <span class="text-danger text-sm" v-show="errors.has('step-1.servizio')">{{ errors.first('step-1.servizio') }}</span>
                  </vs-col>
                  <vs-col class="mt-2">
                    <label class="vs-input--label">Nome Cognome (Consulente/Operatore del servizio)</label>
                    <v-select :disabled="checkDisabled" placeholder="Scegli operatore..." :options="operatoriFiltered" v-model="operatore_nome" name="operatore_nome" v-validate="'required'" :filterable="true"><span slot="no-options">Nessun risultato</span></v-select>
                    <!-- <vs-input :disabled="checkDisabled" v-model="operatore_nome" class="w-full" name="operatore_nome" placeholder="Inserisci Operatore" v-validate="'required'" /> -->
                    <span class="text-danger text-sm" v-show="errors.has('step-1.operatore_nome')">{{ errors.first('step-1.operatore_nome') }}</span>
                  </vs-col>
                </vs-col>
                <vs-col class="md:w-6/12 w-full">
                  <vs-col class="mt-4">
                    <h5><span v-if="this.id">Rimborso n. {{n_rimborso}} </span>Creato il {{[': ',$tariffe.formatDateNew(this.data_inserimento)].join(' ')}}</h5>
                  </vs-col>
                  <vs-col class="mt-2">
                    <label class="vs-input--label">Destinato a</label>
                    <v-select :disabled="checkDisabled" placeholder="Scegli..." :options="['Ascom','Cedascom']" v-model="destinatario" name="destinatario" v-validate="'required'" :filterable="false" />
                    <span class="text-danger text-sm" v-show="errors.has('step-1.destinatario')">{{ errors.first('step-1.destinatario') }}</span>
                  </vs-col>
                  <vs-col class="mt-2">
                    <label class="vs-input--label">Anno insorgenza errore</label>
                    <vs-input :disabled="checkDisabled" v-model="anno_insorgenza_errore" class="w-full" name="anno_insorgenza_errore" placeholder="Inserisci anno" v-validate="'required'" />
                    <span class="text-danger text-sm" v-show="errors.has('step-1.anno_insorgenza_errore')">{{ errors.first('step-1.anno_insorgenza_errore') }}</span>
                  </vs-col>
                  <vs-col class="mt-2">
                    <label class="vs-input--label">Importo</label>
                    <vs-input :disabled="checkDisabled" class="w-full" v-currency="{}" v-model="importo" name="importo" v-validate="'required'" />
                    <span class="text-danger text-sm" v-show="errors.has('step-1.importo')">{{ errors.first('step-1.importo') }}</span>
                  </vs-col>
                  <!-- <vs-col class="mt-2" :vs-w="$parseCurrency(importo) > 1500 ? 6 : 12"> -->
                  <vs-col class="mt-2">
                    <label class="vs-input--label">Sinistro con seguito</label>
                    <vs-checkbox :disabled="checkDisabled" v-model="seguito_sinistro" />
                  </vs-col>
                  <!-- <vs-col v-if="$parseCurrency(importo) > 1500" class="mt-2" vs-w="6">
                    <label class="vs-input--label">Apertura sinistro Assicurazione</label>
                    <vs-checkbox :disabled="checkDisabled" v-model="apertura_sinistro" />
                  </vs-col> -->
                  <vs-col class="mt-2">
                    <label class="vs-input--label">Iban</label>
                    <vs-input :disabled="checkDisabled" v-model="iban" class="w-full" name="iban" placeholder="Inserisci Iban" v-validate="'iban|required'" />
                    <span class="text-danger text-sm" v-show="errors.has('step-1.iban')">{{ errors.first('step-1.iban') }}</span>
                  </vs-col>
                </vs-col>
              </vs-row>
            </form>
          </tab-content>
          <!-- tab 2 content -->
          <tab-content title="Descrizione" class="mb-5" icon="feather icon-type">
            <form data-vv-scope="step-2" v-on:submit.prevent="stop">
              <vs-row>
                <div class="flex items-end px-3 mt-4">
                  <feather-icon svgClasses="w-6 h-6" icon="TypeIcon" class="mr-2 c-primary" />
                  <span class="font-medium text-lg leading-none">Descrizione del fatto e motivazione della richiesta</span>
                </div>
                <vs-divider />
              </vs-row>
              <vs-row class="m-top-5">
               <vs-col class="lg:w-5/5 w-full">
               <quill-editor :disabled="checkDisabled" ref="myQuill" v-model="note"></quill-editor>
              </vs-col>
            </vs-row>
            </form>
          </tab-content>
          <!-- tab 3 content -->
          <tab-content title="Allegati" class="mb-5" icon="feather icon-list">
            <StepDocumentazione :form="documentazione" />
          </tab-content>
          <!-- tab 3_bis content -->
          <tab-content v-if="selected && selected.assicurazione" title="Assicurazione" class="mb-5" icon="feather icon-corner-down-left" :before-change="validateStep3Bis">
            <form data-vv-scope="step-3-bis">
              <vs-row>
                <vs-col class="md:w-6/12 w-full" w="2">
                  <vs-col class="mt-2">
                    <label class="vs-input--label">Compagnia assicurativa</label>
                    <vs-input v-model="compagnia_assicurazione" class="w-full" name="compagnia_assicurazione" placeholder="Inserisci compagnia assicurativa" v-validate="'required'" />
                    <span class="text-danger text-sm" v-show="errors.has('step-3-bis.compagnia_assicurazione')">{{ errors.first('step-3-bis.compagnia_assicurazione') }}</span>
                  </vs-col>
                  <vs-col class="mt-2">
                    <label class="vs-input--label">Numero pratica assicurazione</label>
                    <vs-input v-model="numero_polizza_assicurazione" class="w-full" name="numero_polizza_assicurazione" placeholder="Inserisci numero pratica" v-validate="'required'" />
                    <span class="text-danger text-sm" v-show="errors.has('step-3-bis.numero_polizza_assicurazione')">{{ errors.first('step-3-bis.numero_polizza_assicurazione') }}</span>
                  </vs-col>
                  <vs-col class="mt-2">
                    <label class="vs-input--label">Data apertura pratica</label>
                    <datepicker typeable  placeholder="Scegli la data di apertura" :language="languages['it']" :format="datepicker_format" name="data_apertura_assicurazione" v-validate="'required'" v-model="data_apertura_assicurazione"></datepicker>
                    <span class="text-danger text-sm" v-show="errors.has('step-3-bis.data_apertura_assicurazione')">{{ errors.first('step-3-bis.data_apertura_assicurazione') }}</span>
                  </vs-col>
                </vs-col>
                <vs-col class="md:w-6/12 w-full" w="2">
                  <vs-col class="mt-2">
                    <label class="vs-input--label">Importo</label>
                    <vs-input class="w-full" v-currency="{}" v-model="importo" name="importo" v-validate="'required'" />
                    <span class="text-danger text-sm" v-show="errors.has('step-3-bis.importo')">{{ errors.first('step-3-bis.importo') }}</span>
                  </vs-col>
                  <vs-col class="mt-2">
                    <label class="vs-input--label">Importo rimborsato</label>
                    <vs-input class="w-full" v-currency="{}" v-model="importo_rimborsato_assicurazione" name="importo_rimborsato_assicurazione" v-validate="'required'" />
                    <span class="text-danger text-sm" v-show="errors.has('step-3-bis.importo_rimborsato_assicurazione')">{{ errors.first('step-3-bis.importo_rimborsato_assicurazione') }}</span>
                  </vs-col>
                  <vs-col class="mt-2">
                    <label class="vs-input--label">Data liquidazione pratica</label>
                    <datepicker typeable  placeholder="Scegli la data di lliquidazione" :language="languages['it']" :format="datepicker_format" name="data_liquidazione_assicurazione" v-validate="'required'" v-model="data_liquidazione_assicurazione"></datepicker>
                    <span class="text-danger text-sm" v-show="errors.has('step-3-bis.data_liquidazione_assicurazione')">{{ errors.first('step-3-bis.data_liquidazione_assicurazione') }}</span>
                  </vs-col>
                </vs-col>
              </vs-row>
              <vs-row class="m-top-5">
               <vs-col class="lg:w-5/5 w-full">
               </vs-col>
              </vs-row>
            </form>
          </tab-content>
        </form-wizard>
      </div>
    </vs-col>
  </vs-row>
</template>

<script>
import FormWizard from '@/components/vue-form-wizard/FormWizard.vue'
import TabContent from '@/components/vue-form-wizard/TabContent.vue'
// import ItemListView from '@/components/ItemListView.vue'
import 'vue-form-wizard/dist/vue-form-wizard.min.css'
// import ShowPreventivo from './ShowPreventivo.vue'
import StepDocumentazione from './StepDocumentazione.vue'

// For custom error message
import { Validator } from 'vee-validate';

// axios
import axios from 'axios'

// vue-select
import vSelect from 'vue-select'

// datepicker + languages
import Datepicker from '@sum.cumo/vue-datepicker';
import '@sum.cumo/vue-datepicker/dist/vuejs-datepicker.css'
import * as lang from 'vuejs-datepicker/src/locale';

// required for quillEditor
import 'quill/dist/quill.core.css'
import 'quill/dist/quill.snow.css'
import 'quill/dist/quill.bubble.css'

import { quillEditor } from 'vue-quill-editor'

const dict = {
  custom: {
    azienda: {
      required: 'Selezionare un\'Azienda',
    },
    contatto: {
      required: 'Selezionare un Contatto',
    },
    destinatario: {
      required: 'Selezionare un Destinatario'
    },
    servizio: {
      required: 'Servizio è un campo obbligatorio'
    },
    codice_ufficio: {
      required: 'Codice Ufficio è un campo obbligatorio'
    },
    anno_insorgenza_errore: {
      required: 'Anno insorgenza errore è un campo obbligatorio'
    },
    operatore_nome: {
      required: 'Operatore è un campo obbligatorio'
    },

    importo: {
      required: 'Importo è un campo obbligatorio',
      decimal: 'Inserire un numero'
    },

    iban: {
      required: 'Iban è un campo obbligatorio',
      iabn: 'Iban non valido'
    },

    compagnia_assicurazione: {
      required: 'Compagnia assicurativa è un campo obbligatorio'
    },

    numero_polizza_assicurazione: {
      required: 'Numero polizza è un campo obbligatorio'
    },

    data_apertura_assicurazione: {
      required: 'Data apertura è un campo obbligatorio'
    },

    importo_rimborsato_assicurazione: {
      required: 'Importo rimborsato è un campo obbligatorio',
      decimal: 'Inserire un numero'
    },

    data_liquidazione_assicurazione: {
      required: 'Data liquidazione è un campo obbligatorio'
    },
  }
};

// register custom messages
Validator.localize('it', dict);

function isIban(iban) {
  var IBAN = require('iban');
  return IBAN.isValid(iban)
}

Validator.extend('iban', isIban);

export default {
  data() {
    return {
      is_loading: null,

      datepicker_format: "d.MM.yyyy",
      languages: lang,

      numero: null,
      n_rimborso: '',
      contatti: [],
      contatto: null,
      aziende: [],
      azienda: null,

      stato: {},
      servizi: [],
      servizio: null,
      operatori: [],
      operatore_nome: "",
      codici_ufficio: [],
      codice_ufficio: null,

      id: null,

      destinatario: "",
      anno_insorgenza_errore: "",

      data_inserimento: "",

      importo: null,
      seguito_sinistro: false,
      apertura_sinistro: null,
      iban: "",

      note: "",

      radio_ca: 'azienda',
      selectorKey: null,
      return_logo_string: 'CEDASCOM',

      verify: {},
      documentazione: [],
      // assicurazione
      compagnia_assicurazione: "",
      numero_polizza_assicurazione: "",
      data_apertura_assicurazione: "",
      importo_rimborsato_assicurazione: null,
      data_liquidazione_assicurazione: "",
    }
  },
  props: {
    selected: Object,
    isResponsabile: Boolean,
  },
  computed: {
    currentUserId() {
      return localStorage.utente_id
    },
    checkDisabled() {
      if (this.selected && this.selected.creatore && (this.selected.creatore.id == this.currentUserId))
        return false
      else if (!this.selected) return false
      else if (this.selected.stato_num == 0 && this.isResponsabile) return false
      else return true
    },
    operatoriFiltered() {
      if (this.codice_ufficio && this.servizio) {
        // this.operatore_nome = ""
        return this.operatori.filter( op => {
          if (op.ufficio == this.codice_ufficio.descrizione.toUpperCase() && op.servizio == this.servizio.codice.toUpperCase())
            return op
        })
      }
      else {
        // this.operatore_nome = ""
        return []
      }
    },
  },
  methods: {
    fetchAziende(q, loading) {
      if (q.trim().length < 3) {
        this.aziende = []
        this.contatti = []
        return
      }
      loading(true)
      axios.post(process.env.VUE_APP_BACKEND_API+'/azienda/trova_live', { keyword: q }, {
        headers: { "Access-Control-Allow-Origin": "*", 'Content-Type': 'application/json',},
        withCredentials: true,
      }).then(e => {
        this.contatto = null
        this.contatti = []
        this.aziende = e.data.map(e => {
          e['label'] = `${e['ragione_sociale']} - ${e['codice_fiscale']}`
          return e
        })
        loading(false)
      })
    },
    fetchContatti(q, loading) {
      if (q.trim().length < 3) {
        this.aziende = []
        this.contatti = []
        return
      }
      loading(true)
      axios.post(process.env.VUE_APP_BACKEND_API+'/contatto/trova_live', { keyword: q }, {
        headers: { "Access-Control-Allow-Origin": "*", 'Content-Type': 'application/json',},
        withCredentials: true,
      }).then(e => {
        this.aziende = []
        this.azienda = null
        this.contatti = e.data.map(e => {
          e['label'] = `${e['nome']} ${e['cognome']}`
          return e
        })
        loading(false)
      })
    },
    getServizi() {
      axios.get(process.env.VUE_APP_BACKEND_API+'/tariffa_servizio/trova_servizi_crm',
                {headers: { "Access-Control-Allow-Origin": "*", 'Content-Type': 'application/json',},
                withCredentials: true,
      }).then(response => (
        this.servizi = response.data.map(e => {
                                  e['label'] = e['codice']
                                  return e
                                })))
      // .catch(e => console.log(e))
    },
    getUffici() {
      axios.get(process.env.VUE_APP_BACKEND_API+'/azienda/get_uffici',
                {headers: { "Access-Control-Allow-Origin": "*", 'Content-Type': 'application/json',},
                withCredentials: true,
      }).then(response => {
        this.codici_ufficio = response.data.map(e => {
                                  e['label'] = `${e['descrizione']} ( ${e['codice']} )`
                                  return e
                                })
        if (this.codice_ufficio && this.codice_ufficio.length) {
          this.codice_ufficio = this.codici_ufficio.find( el => {
            if (el.codice.toString() == this.codice_ufficio) {
              return el
            }
          })
        }
      })
      // .catch(e => console.log(e))
    },
    getOperatori() {
      axios.get(process.env.VUE_APP_BACKEND_API+'/tariffa_servizio/get_operatori_rimborso',
                {headers: { "Access-Control-Allow-Origin": "*", 'Content-Type': 'application/json',},
                withCredentials: true,
      }).then(response => {
        this.operatori = response.data.map(e => {
                                  e['label'] = e['nome']
                                  return e
                                })
        if (this.selected && this.selected.operatore_nome.length) {
          this.operatore_nome = this.operatori.find( el => {
            if (el.nome.toString() == this.selected.operatore_nome) {
              return el
            }
          })
        }
      })
    },
    validateStep1() {
      return new Promise((resolve, reject) => {
        this.$validator.validateAll('step-1').then(result => {
          if (result) {
            resolve(true)
          } else {
            reject("correct all values");
          }
        })
      })
    },
    validateStep3Bis() {
      return new Promise((resolve, reject) => {
        this.$validator.validateAll('step-3-bis').then(result => {
          if (result) {
            resolve(true)
          } else {
            reject("correct all values");
          }
        })
      })
    },
    onSalva() {
      if (this.is_loading) return true
      this.is_loading = true
      let url = this.id ? process.env.VUE_APP_BACKEND_API+'/rimborso/modifica' : process.env.VUE_APP_BACKEND_API+'/rimborso/crea'
      let obj = this.buildSaveObject()
      if (this.id) {
        obj['id'] = this.id
      }
      axios.post(url, obj,{
        headers: { "Access-Control-Allow-Origin": "*", 'Content-Type': 'application/json',},
        withCredentials: true,
      })
      .then(response => {
        this.$vs.notify({
          color: 'success',
          time: 4000,
          title: 'Rimborso',
          text: `${this.id ? 'Aggiornamento riuscito' : 'Inserimento avvenuto'}`,
          icon:'mail'
        })
        this.is_loading = false
        this.$emit('rimborso-creato', 'OK')
      })
    },
    buildSaveObject() {
      let d = this.$refs.myQuill
      let obj = {
        codice_ufficio: this.codice_ufficio.codice,
        id_servizio: this.servizio.id,
        operatore_nome: this.operatore_nome.nome,

        destinatario: this.destinatario,
        anno_insorgenza_errore: this.anno_insorgenza_errore,
        importo: this.$parseCurrency(this.importo),

        seguito_sinistro: this.seguito_sinistro ? true : false,
        iban: this.iban,

        note: this.note,
        note_plain: d.quill.container.innerText,

        documentazione: this.documentazione
      }

      // if (this.importo > 1500) {
      //   obj['apertura_sinistro'] = this.apertura_sinistro ? true : false
      // }

      if (this.contatto) {
        obj['id_contatto'] = this.contatto.id
      }
      else {
        obj['id_azienda'] = this.azienda.id
      }

      if ( !this.id ) { // set stato to Creato
        obj['stato'] = "create"
        obj['stato_label'] = "Creato"
      } else if (this.stato == 'request') {
        obj['numero'] = this.numero
        obj['data_inserimento'] = this.data_inserimento

        obj['richiedente_mail'] = this.selected.stati.find( s => s.stato == 'request').utente.email
        obj['stato'] = "update"
        obj['stato_label'] = "Modificato"
        obj['stato_num'] = 5
      }
      // else if (this.stato == 'paid') {
      //
      // }
      if (this.assicurazione) {
        obj['compagnia_assicurazione'] = this.compagnia_assicurazione
        obj['numero_polizza_assicurazione'] = this.numero_polizza_assicurazione
        obj['data_apertura_assicurazione'] = this.data_apertura_assicurazione
        obj['importo_rimborsato_assicurazione'] = this.$parseCurrency(this.importo_rimborsato_assicurazione)
        obj['data_liquidazione_assicurazione'] = this.data_liquidazione_assicurazione
      }
      obj['id_servizio'] = this.servizio.id
      return obj
    },
    stop(ev) {
      ev.stopPropagation()
    },
    closeSidebar(ev) {
      this.$emit('close-me')
      ev.stopPropagation()
    },
  },
  created() {
    this.getServizi()
    this.getUffici()
    this.getOperatori()
    if (this.selected) {
      Object.keys(this.selected).forEach(e => this[e] = !this.selected[e] ? "" : this.selected[e])
      if (this.selected.contatto) {
        this.contatto = this.selected.contatto
        this.contatto['label'] = [this.contatto.nome,this.contatto.cognome].join(' ')
        this.radio_ca = 'contatto'
      }
      if (this.selected.azienda) {
        this.azienda = this.selected.azienda
        this.azienda['label'] = [this.azienda.tipo_azienda,this.azienda.ragione_sociale].join(' ')
      }
      this.codice_ufficio = this.selected.ufficio
      this.codice_ufficio['label'] = `${this.selected.ufficio['descrizione']} ( ${this.selected.ufficio['codice']} )`
      this.servizio = this.servizi.find(e => e.label == this.selected.servizio.codice)
      this.servizio = this.selected.servizio
      this.servizio['label'] = this.selected.servizio.codice
      if (!this.selected.id || !this.selected.data_inserimento) {
        this.data_inserimento = new Date()
      }
      let d_n = new Date(this.data_inserimento).getYear() + 1900
      this.n_rimborso = [this.numero,'/',d_n].join('')
    } else {
      // console.log('NUOVO RIMBORSO');
      this.data_inserimento = new Date()
    }
  },
  components: {
    Datepicker,
    FormWizard,
    TabContent,
    // ItemListView,
    'v-select': vSelect,
    // ShowPreventivo,
    StepDocumentazione,
    quillEditor,
  },
  watch: {
    radio_ca (val) {
      this.selectorKey = Math.random()
      if (val == 'azienda') this.contatto = null
      else this.azienda = null
    },
    codice_ufficio () {
      if (!this.checkDisabled) this.operatore_nome = ""
    },
    servizio () {
      if (!this.checkDisabled) this.operatore_nome = ""
    },
  },
}
</script>
